import { useEffect } from 'react';
import useIsInIframe from './useIsInIframe';

/**
 * Custom hook to handle iframelang URL parameter changes during navigation
 * Note: Initial language setup is handled synchronously in index.js before React renders
 * This hook only handles URL changes during navigation (popstate events)
 */
const useIframeLanguage = () => {
  const isInIframe = useIsInIframe();

  // Listen for popstate events to handle URL changes during navigation
  useEffect(() => {
    if (!isInIframe) {
      return;
    }

    const handleLocationChange = () => {
      const searchParams = new URLSearchParams(window.location.search);
      const iframeLang = searchParams.get('iframelang');

      if (iframeLang) {
        // Validate and normalize the language value (case-insensitive)
        const normalizedLang = iframeLang.trim().toLowerCase();
        let validLang = null;

        if (normalizedLang === 'spanish' || normalizedLang === 'español' || normalizedLang === 'espanol') {
          validLang = 'Spanish';
        } else if (normalizedLang === 'english' || normalizedLang === 'en' || normalizedLang === 'eng') {
          validLang = 'English';
        }

        if (validLang) {
          localStorage.setItem('language', validLang);
          // Dispatch langChanged event to update all components
          window.dispatchEvent(new CustomEvent('langChanged', { detail: validLang }));
        }
      }
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, [isInIframe]);
};

export default useIframeLanguage;

